<template>
<el-collapse-item :name="infoObj.nbhdGuid">
  <div slot="title" class="nbhd_header">
    <div class="plot_name">
      <el-checkbox
        @click.stop.native="() => {}"
        :indeterminate="infoObj.isIndeterminate"
        v-model="infoObj.checked"
        @change="handleCheckNbhd">
      </el-checkbox>
      <span>
        {{infoObj.nbhdName}}
        <span class="plot_addr">{{infoObj.nbhdAddress}}</span>
      </span>
    </div>
    <div class="plot_devices">
      <!-- <span>
        合计金额：
        <span class="total_money">{{totalFee(infoObj)}}元</span>
      </span> -->
      <span>
        总屏幕数：
        <span class="total_screen_num">{{totalDeviceCount}}个</span>
      </span>
    </div>
  </div>
  <!-- 楼幢list 性能优化:使用lazy模式只有当用户手动展开某个小区时才渲染该小区下的楼幢及单元列表 -->
  <!-- <el-collapse class="build_list_collapse" v-if="curActive.length && curActive.indexOf(infoObj.nbhdGuid) !== -1"> -->
  <el-collapse class="build_list_collapse">
    <MonitBuild
      v-for="(bItem, i) in infoObj.nbhdDeviceInfo"
      :key="bItem.build + '__' + i"
      :transport.sync="bItem"
      @check-change="checkChange">
    </MonitBuild>
  </el-collapse>
</el-collapse-item>
</template>

<script>
import ListMixin from './mixin/ListMixin'
import MonitBuild from '@/components/MonitService/MonitBuild'

export default {
  name: 'MonitNbhd',
  components: { MonitBuild },
  mixins: [ ListMixin ],
  props: {
    curActive: {
      type: [Array, String],
      default () {
        return []
      }
    }
    // transport: {
    //   type: Object,
    //   default () {
    //     return {
    //       address: '',
    //       nbhdDeviceInfo: [],
    //       nbhdGuid: 0,
    //       nbhdName: '',
    //     }
    //   }
    // }
  },
  data() {
    return {}
  },
  computed: {
    // totalFee () {
    //   return item => { return item.slotAmount ? Number(item.slotAmount).toFixed(2) : '0.00' }
    // }
  },
  destroyed () {
    this.infoObj = null
  },
  created () {
    // if (this.infoObj.nbhdGuid === 1) {
    //   console.time(`挂载${this.infoObj.nbhdName}小区组件`)
    //   console.time(`渲染${this.infoObj.nbhdName}小区组件`)
    // }
  },
  mounted () {
    // if (this.infoObj.nbhdGuid === 1) {
    //   console.timeEnd('获得数据到挂载小区组件耗时')
    //   console.timeEnd(`挂载${this.infoObj.nbhdName}小区组件`)
    //   this.$nextTick(() => {
    //     console.timeEnd(`渲染${this.infoObj.nbhdName}小区组件`)
    //     console.timeEnd('获得数据到第一个小区组件渲染完成耗时')
    //   })
    // }
  },
  methods: {
    handleCheckNbhd (val) {
      console.log('勾选' + this.infoObj.nbhdName + '小区：', val)
      this.changeItemStatus(this.infoObj, val)
      this.$emit('check-change')
    }
  }
}
</script>

<style lang="scss" scoped>
.nbhd_header {
  width: calc(100% - 21px);
  color: #999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 12px;
  .plot_name {
    color: #282729;
    font-size: 16px;
    width: calc(100% - 107px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ::v-deep .el-checkbox {
      margin-right: 10px;
    }
    .plot_addr {
      color: #999999;
      font-size: 12px;
    }
  }
  .plot_devices {
    min-width: 107px;
    flex-shrink: 0;
    text-align: right;
    .total_money {
      color: #FF3973;
      margin-right: 20px;
      padding-right: 20px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        background: #D4D4D4;
        right: 0;
        width: 1px;
        height: 14px;
        top: 3px;
      }
    }
    .total_screen_num {
      color: #282729;
      font-weight: 600;
    }
  }
}
::v-deep .el-collapse.build_list_collapse {
  background: #ffffff;
  border-top: none;
  border-color: #E9E9E9;
  .el-collapse-item__header {
    background: transparent;
    height: 40px;
    line-height: 40px;
  }
  .el-collapse-item__wrap {
    background: transparent;
    border-bottom: none;
    overflow: visible;
    .el-collapse-item__content {
      padding-bottom: 0;
    }
  }
}
::v-deep .el-collapse-item__arrow {
  margin-right: 0;
}
</style>
